

$w.onReady(function () {

	// const LSO_AUDITION_DEADLINE = new Date ("2022-08-26 21:00");
	// const LSYO_AUDITION_DEADLINE = new Date ("2022-08-26 3:59");

	// var currentDate = new Date();

	
	// // console.log("Now = " + currentDate);
	// // console.log("LSYO_AUDITION_DEADLINE = " + LSYO_AUDITION_DEADLINE);
	
    // if (currentDate >= LSYO_AUDITION_DEADLINE) {
    //     $w('#lsyoAuditionArt').hide();
    //     $w('#lsyoAuditionArt').collapse();
    //     $w('#lsoAuditionArtRight').hide();
    //     $w('#lsoAuditionArtRight').collapse();
    //     $w('#lsoAuditionArtCenter').show();
    //     $w('#lsoAuditionArtCenter').expand();
    // // } else {
    // }

	
	// // console.log("Now = " + currentDate);
	// // console.log("LSO_AUDITION_DEADLINE = " + LSO_AUDITION_DEADLINE);

    // if (currentDate >= LSO_AUDITION_DEADLINE) {
    //     // $w('#lsoAuditionArtRight').hide();
    //     // $w('#lsoAuditionArtRight').collapse();
    //     $w('#lsoAuditionArtCenter').hide();
    //     $w('#lsoAuditionArtCenter').collapse();
	// }

});

